import { APP_INITIALIZER, ApplicationConfig, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { routes } from './app.routes';
import { authInterceptor } from '../core/auth/interceptor/auth.interceptor';
import { credentialsInterceptor } from '../core/auth/interceptor/credentials.interceptor';
import { csrfInterceptor } from '../core/auth/interceptor/csrf.interceptor';
import { csrfRefreshInterceptor } from '../core/auth/interceptor/csrf-refresh.interceptor';
import { provideToastr } from 'ngx-toastr';
import { AuthService } from '../core/auth/services/auth.service';
import { CsrfBootstrapService } from '../core/auth/services/csrf-bootstrap.service';

function initializeApp(
  authService: AuthService,
  platformId: object
): () => Promise<void> {
  return () => {
    if (isPlatformBrowser(platformId)) {
      authService.bootstrap();
    }
    return Promise.resolve();
  };
}

export const appConfig: ApplicationConfig = {

  providers: [
    provideClientHydration(
      withHttpTransferCacheOptions({
        includeHeaders: ['X-XSRF-TOKEN']
      })
    ),

    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AuthService, PLATFORM_ID],
      multi: true
    },

    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top'
      })
    ),

    provideHttpClient(
      withFetch(),
      withInterceptors([
        credentialsInterceptor,
        csrfRefreshInterceptor,
        authInterceptor,
        csrfInterceptor
      ])
    ),

    provideAnimations(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 3000,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true,
      newestOnTop: true,
      easing: 'ease-in-out',
      easeTime: 300
    })
  ]

};